import '@/plugins/bootstrapv3/js/bootstrap.js';
import '@/plugins/bootstrapv3/css/bootstrap.css';
import '@/plugins/bootstrapv3/css/bootstrap-theme.css';
import '@/plugins/font-awesome/less/font-awesome.less';
import '@/plugins/jquery-iealert/jquery.iealert.js';
import '@/plugins/jquery-iealert/jquery.iealert.css';
import 'shepherd.js/dist/css/shepherd.css';
import '@fontsource/roboto/100.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import '@fontsource/roboto/900.css';
import { initAnalytics } from './analytics';

import { createApp } from 'vue';

import CxShell from '@/app/CxShell.vue';
import router from '@/plugins/vue-router.instance';
import gettext from '@/plugins/gettext.instance';

const rootElementId = '#cx-ui-login';

// App initialization
const app = createApp(CxShell);
app.use(router);
app.use(gettext);
app.mount(rootElementId);

initAnalytics({
  AMPLITUDE_API_KEY: process.env.CONX_AMPLITUDE_API_KEY,
});
